import { Button, Tooltip, type ButtonProps } from '@mui/material';

type TooltipButtonProps = {
    title: string;
} & ButtonProps;

export const TooltipButton = ({ title, children, ...rest }: TooltipButtonProps) => {
    return (
        <Tooltip title={title} placement='top'>
            <Button size='small' {...rest}>
                {children}
            </Button>
        </Tooltip>
    );
};
